import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { replaceToLandingSSR } from 'utils/navigateLandingSSR'

const AuthRoute = ({ children }) => {
  const protectedPath = [
    '/login',
    '/register',
    '/confirm-email',
    '/forgot-password',
    '/reset-password'
  ]
  const { pathname } = useLocation()
  const isAuth = useSelector((state) => state.auth)

  if (isAuth?.access_token && protectedPath.find((path) => path === pathname)) {
    return replaceToLandingSSR()
  }
  return children
}

export default AuthRoute
